import {
  AllowedCountryCode,
  AllowedCurrencyCode,
  LineItem,
} from '@nrdy-marketing-engine/cart/@types/cart-state';
import type { PaymentMethodPayload } from 'braintree-web-drop-in';

interface PaymentBuilderProps {
  billingAddress: {
    city: string;
    countryCode?: string;
    line1: string;
    line2: string;
    postalCode?: string;
    state: string;
  };
  countryCode: AllowedCountryCode;
  currencyCode: AllowedCurrencyCode;
  email: string;
  firstName: string;
  lastName: string;
  lineItems: LineItem[];
  nonce: string;
  numberOfPayments?: number;
  paymentAmount: number;
  paymentType: PaymentMethodPayload['type'];
  phoneNumber: string;
  zipCode: string;
}

export default function paymentBuilder({
  billingAddress,
  countryCode,
  currencyCode,
  email,
  firstName,
  lastName,
  nonce,
  numberOfPayments = 1,
  paymentType,
  paymentAmount,
  phoneNumber,
  zipCode,
}: PaymentBuilderProps) {
  const quoteId = new URLSearchParams(window.location.search).get('q')?.toLowerCase();
  const paymentsParam = quoteId ? {} : { number_of_payments: numberOfPayments };

  return {
    payment_type: paymentType,
    amount_cents: paymentAmount,
    currency_code: currencyCode,
    nonce,
    billing_address: {
      email: email,
      first_name: firstName,
      last_name: lastName,
      address_1: billingAddress?.line1,
      address_2: billingAddress?.line2,
      phone: phoneNumber,
      city: billingAddress?.city,
      state: billingAddress?.state,
      zip_code: billingAddress?.postalCode || zipCode,
      country_code2: billingAddress?.countryCode || countryCode,
    },
    ...paymentsParam,
  };
}
